import { Component, computed, OnDestroy, OnInit } from '@angular/core';
import { NotificationService } from './components/services/notification.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DotLoadingServices } from './core';
import { initFlowbite } from 'flowbite';
import { LoadingService } from './core/components/loading/loading.service';
import { Subscription } from 'rxjs';
import { signal } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
    loading: boolean = false;
    isLoginPage = signal<boolean>(false);
    isLoading = computed(() => this.dotLoadingServices.isLoading());
    notifications = computed(() => this.notificationService.notification());
    private subscriptions: Subscription = new Subscription();

    title = 'Maxim-ERP';

    constructor(
        private loadingService: LoadingService,
        public dotLoadingServices: DotLoadingServices,
        public notificationService: NotificationService,
        private router: Router
    ) {
        // Set initial isLoginPage value synchronously
        this.isLoginPage.set(this.router.url.includes('/login'));
    }

    ngOnInit() {
        initFlowbite();

        // Subscribe to loading service
        this.subscriptions.add(
            this.loadingService.isLoading.subscribe((isLoading) => {
                this.dotLoadingServices.set(isLoading);
            })
        );

        // Subscribe to router events for subsequent navigation
        this.subscriptions.add(
            this.router.events.pipe(
                filter((event): event is NavigationEnd => event instanceof NavigationEnd)
            ).subscribe((event: NavigationEnd) => {
                this.isLoginPage.set(event.urlAfterRedirects.includes('/login'));
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}